import React from 'react'

import Appbar from '../components/appbar/Appbar'
import { ThemeProvider } from '@mui/system'
import theme, { Colors } from '../styles/theme/'
import Products from '../components/products/Products'
import GotoCart from '../components/GotoCart'
import Banner from '../components/banner'
import {
    Box,
    Container,
    Typography,
    Stack,
    Divider,
    CssBaseline,
} from '@mui/material'
import { UIProvider } from '../context/ui/'
import Footer from '../components/footer'
import AppDrawer from '../components/drawer'
import PageFooter from '../components/PageFooter.js'
import { Helmet } from 'react-helmet-async'
import { ProductSchema, OrganizationSchema } from '../components/ProductSchema'
import { useShoppingCart } from '../context/ShoppingCartContext'

export default function Shop() {
    const { data, isCAD } = useShoppingCart()

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            {/* Page Meta Tags */}
            <Helmet>
                <title>
                    ElectroBraid® Online Store – Electric Horse Fence Products
                </title>
                <link rel="canonical" href="https://electrobraid.com/shop" />
            </Helmet>

            {/* Structured Data for SEO */}
            <ProductSchema products={data} isCAD={isCAD} />
            <OrganizationSchema />
            <Container
                sx={{
                    background: theme.palette.primary.main,
                    border: `solid 1px ${Colors.secondary}`,
                }}
            >
                <Stack>
                    <UIProvider>
                        <Appbar />
                        <Banner />

                        <Box
                            display="flex"
                            justifyContent="center"
                            sx={{ mt: 5, mb: 1 }}
                        >
                            {/* UPDATED: Clean, modern products heading */}
                            <Typography
                                id="section1"
                                variant="h2"
                                sx={{
                                    fontSize: '3rem',
                                    fontWeight: 700,
                                    color: Colors.secondary, // CHANGED: Dark green for professionalism
                                    textAlign: 'center',
                                    mb: 0, // ADDED: Margin bottom
                                    position: 'relative',
                                    // Removed: border, backgroundColor, excessive padding
                                    // Added: Underline accent via ::after
                                    textShadow: `${Colors.boltGold2} 1px 1px 1px, ${Colors.boltGold2} 0.25px 0.25px 0.25px`,
                                    '&::after': {
                                        content: '""',
                                        display: 'block',
                                        width: '160px',
                                        height: '4px',
                                        backgroundColor: Colors.boltGold, // Gold accent
                                        margin: '16px auto 0',
                                        borderRadius: '2px',
                                    },
                                    // Responsive sizing
                                    [theme.breakpoints.down('md')]: {
                                        fontSize: '2.5rem',
                                    },
                                    [theme.breakpoints.down('sm')]: {
                                        fontSize: '2rem',
                                    },
                                }}
                            >
                                Our Products
                            </Typography>
                        </Box>
                        <Divider
                            orientation="horizontal"
                            variant="middle"
                            flexItem
                            sx={{
                                marginBottom: '2rem',
                                marginTop: '1rem',
                            }}
                        />
                        <Products />

                        <GotoCart />

                        <Footer />
                        <AppDrawer />
                    </UIProvider>
                </Stack>

                <PageFooter />
            </Container>
        </ThemeProvider>
    )
}
// perhaps https://codesandbox.io/p/sandbox/48319372-changing-font-family-of-all-material-uiversion-1-components-7o9qe?file=%2Fdemo.js%3A60%2C31
